<div class="generate-promt-modal">
  <div class="header">
    <h4>Generate portrait using prompt</h4>
    <button class="close-button" (click)="closeModal()">
      <img src="assets/icons/icon-close.svg" alt="Close">
    </button>
  </div>
  <div class="generatep-main">
    <div class="generatep-box" [class.loading]="isGenerating">
      @if (isGenerating) {
        <div class="loader-dashes"></div>
      }
    </div>
    <div class="generatep-box" [class.loading]="isGenerating">
      @if (isGenerating) {
        <div class="loader-dashes"></div>
      }
    </div>
    <div class="generatep-box" [class.loading]="isGenerating">
      @if (isGenerating) {
        <div class="loader-dashes"></div>
      }
    </div>
    <div class="generatep-box" [class.loading]="isGenerating">
      @if (isGenerating) {
        <div class="loader-dashes"></div>
      }
    </div>
  </div>
  <div class="btn-wrapper">
    <button type="button" class="btn btn-dark" (click)="generateImage(isGenerated)" [disabled]="isGenerating">
      {{isGenerated ? 'REGENERATE':'GENERATE'}}
      <img src="assets/icons/icon-generate.svg" alt="Generate">
    </button>
  </div>
</div>